import React from 'react'
import PropTypes from 'prop-types'
import VideoLightbox from './VideoLightbox'
import PreviewCompatibleImage from './PreviewCompatibleImage'
import MarkdownRenderer from './MarkdownRenderer'

const TalksHero = ({
  headline,
  subheadline,
  image,
  description,
  video_sv,
  video_en,
}) => {
  return (
    <div className="course-hero">
      <PreviewCompatibleImage
        imageInfo={{ image: image }}
        styles={{ maxHeight: '500px' }}
      />

      <div className="section">
        <div className="columns">
          <div className="column is-4">
            <h2 className="title has-text-primary">{headline}</h2>
            <h3
              className="subtitle is-family-secondary is-uppercase is-size-6"
              dangerouslySetInnerHTML={{ __html: subheadline }}
            ></h3>
          </div>
          <div className="column is-4">
            <MarkdownRenderer
              markdown={description}
              customClass="description"
            />
            <div className="mt-3">
              <div>
                {video_sv ? (
                  <VideoLightbox
                    videolink={video_sv}
                    ctaText="Se video"
                  />
                ) : null}
              </div>
              <div className="mt-3">
                {video_en ? (
                  <VideoLightbox
                    videolink={video_en}
                    ctaText="Watch video (en)"
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className="divider is-hidden-touch" />
    </div>
  )
}

TalksHero.propTypes = {
  headline: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired, // Assuming image prop is a Gatsby image object
  description: PropTypes.string.isRequired,
}

export default TalksHero
